import { NoAlignmentBoxes } from '@upright/ui/common/upright/core/impact-lenses/sdg/data-area/no-alignment-boxes';
import { SdgDrillDownBox } from '@upright/ui/common/upright/core/impact-lenses/sdg/info-boxes/sdg-drilldown-box';

export function SdgDivBoxes() {
  return (
    <>
      <NoAlignmentBoxes />
      <SdgDrillDownBox />
    </>
  );
}
